var _ellipse, _ellipse2, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvlToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.79102,
    cy: 4.6732,
    rx: 4.46875,
    ry: 4.57945,
    fill: "#C19417"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.46875,
    cy: 4.6732,
    rx: 4.46875,
    ry: 4.57945,
    fill: "#DBA81B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 4.6732C8.4375 6.93782 6.64917 8.75265 4.46875 8.75265C2.28833 8.75265 0.5 6.93782 0.5 4.6732C0.5 2.40858 2.28833 0.59375 4.46875 0.59375C6.64917 0.59375 8.4375 2.40858 8.4375 4.6732Z",
    stroke: "black",
    strokeOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2596_3111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.35568 6.03892C2.18054 6.03892 2.0173 6.01081 1.86595 5.95459C1.71676 5.89622 1.58703 5.81405 1.47676 5.70811C1.36649 5.60216 1.28 5.47784 1.2173 5.33514C1.15676 5.19243 1.12649 5.03568 1.12649 4.86486C1.12649 4.69405 1.15676 4.5373 1.2173 4.39459C1.28 4.25189 1.36649 4.12757 1.47676 4.02162C1.58919 3.91568 1.72 3.83459 1.86919 3.77838C2.01838 3.72 2.18162 3.69081 2.35892 3.69081C2.55568 3.69081 2.73297 3.72541 2.89081 3.79459C3.05081 3.86162 3.18486 3.96108 3.29297 4.09297L2.95568 4.40432C2.87784 4.31568 2.79135 4.24973 2.69622 4.20649C2.60108 4.16108 2.4973 4.13838 2.38486 4.13838C2.27892 4.13838 2.18162 4.15568 2.09297 4.19027C2.00432 4.22486 1.92757 4.27459 1.8627 4.33946C1.79784 4.40432 1.74703 4.48108 1.71027 4.56973C1.67568 4.65838 1.65838 4.75676 1.65838 4.86486C1.65838 4.97297 1.67568 5.07135 1.71027 5.16C1.74703 5.24865 1.79784 5.32541 1.8627 5.39027C1.92757 5.45514 2.00432 5.50486 2.09297 5.53946C2.18162 5.57405 2.27892 5.59135 2.38486 5.59135C2.4973 5.59135 2.60108 5.56973 2.69622 5.52649C2.79135 5.48108 2.87784 5.41297 2.95568 5.32216L3.29297 5.63351C3.18486 5.76541 3.05081 5.86595 2.89081 5.93514C2.73297 6.00432 2.55459 6.03892 2.35568 6.03892ZM4.31936 6L3.3399 3.72973H3.90747L4.76368 5.74054H4.42963L5.29882 3.72973H5.82098L4.83828 6H4.31936ZM6.01053 6V3.72973H6.53594V5.57189H7.67432V6H6.01053Z",
    fill: "white",
    fillOpacity: 0.72
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2596_3111",
    x: 1.12646,
    y: 3.69141,
    width: 6.76407,
    height: 2.56387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.216216,
    dy: 0.216216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.18018
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2596_3111"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvlToken);
export default __webpack_public_path__ + "static/media/cvl-token.a2c3b8aa1250b4e16412dedffd8e620a.svg";
export { ForwardRef as ReactComponent };